import { icuOptions } from '../constants/icu-options';
export var createI18n = function (locale, messages, initI18n) {
    var i18n = initI18n({ locale: locale, messages: messages, icuOptions: icuOptions });
    i18n.init();
    return i18n;
};
